// src/app/application-form.routes.ts
import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ENROLLMENT_SHARED_USER_TYPES } from './core/constants/shared.access';

export const applicationFormRoute: Routes = [
    {
        path: 'application-form',
        canActivate: [AuthGuard],
        data: { userTypes: ENROLLMENT_SHARED_USER_TYPES }, // Or create APPLICATION_SHARED_USER_TYPES if different
        loadComponent: () =>
            import('./common/components/applications-stepper/applications-stepper.component').then(
                m => m.ApplicationsStepperComponent
            ),
    }
];